var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Sage_Icon",
    "data-name": "Sage Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.696,
    height: 30,
    viewBox: "0 0 30.696 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1657",
    "data-name": "Path 1657",
    d: "M97.648,151.16c-.291.531-.548,1.045-.548,1.045a32.506,32.506,0,0,0,21.1,9.421,32.552,32.552,0,0,0-4.368-14.526s-.325.565-.788,1.2-.874,1.182-.874,1.182a28.022,28.022,0,0,1,2.569,8l.137.856h0l-.856-.137a27.722,27.722,0,0,1-15.262-7.811l-.411-.411s-.428.685-.719,1.2Z",
    transform: "translate(-87.525 -131.643)",
    fill: "#97999b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1658",
    "data-name": "Path 1658",
    d: "M82.95,89.89c-.428.565-.805.994-.805.994-.257-.274-.514-.548-.788-.822a26.465,26.465,0,0,0-8.65-5.756h0a11.382,11.382,0,0,0,.463,1.045s-.377.36-.805.839-.925,1.062-.925,1.062A26.731,26.731,0,0,1,69.4,81h0a26.414,26.414,0,0,1,13.7,7.3c.188.188.377.394.565.582,0,0-.308.445-.737,1.011Z",
    transform: "translate(-64.569 -76.331)",
    fill: "#97999b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1659",
    "data-name": "Path 1659",
    d: "M109.488,146.925c-.377.463-.788,1.062-.788,1.062.188.206.377.394.582.6a26.414,26.414,0,0,0,13.7,7.3,26.994,26.994,0,0,0-2.038-6.252s-.291.377-.874,1.011-.839.908-.839.908c.154.343.308.685.463,1.045a26.465,26.465,0,0,1-8.65-5.756c-.274-.274-.531-.548-.788-.839,0,0-.36.48-.754.942Z",
    transform: "translate(-97.137 -130.569)",
    fill: "#97999b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1660",
    "data-name": "Path 1660",
    d: "M62.3,62.221A32.506,32.506,0,0,0,41.2,52.8a32.552,32.552,0,0,0,4.368,14.526s.171-.308.805-1.216.839-1.165.839-1.165a27.3,27.3,0,0,1-2.552-8l-.137-.856.856.137a27.722,27.722,0,0,1,15.263,7.811c.137.137.274.274.394.411,0,0,.411-.685.737-1.216.308-.531.548-1.028.548-1.028Z",
    transform: "translate(-41.2 -52.8)",
    fill: "#97999b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1661",
    "data-name": "Path 1661",
    d: "M135.342,94.615c-.463-.377-.942-.788-.942-.788.274-.257.548-.514.822-.788a26.2,26.2,0,0,0,5.756-8.65,11.381,11.381,0,0,0-1.045.463s-.428-.411-.925-.874-.976-.839-.976-.839a26.2,26.2,0,0,1,6.252-2.038,26.414,26.414,0,0,1-7.3,13.7c-.188.188-.394.394-.6.582,0,0-.582-.377-1.045-.754Z",
    transform: "translate(-118.435 -76.458)",
    fill: "#97999b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1662",
    "data-name": "Path 1662",
    d: "M74.642,131.657c-.377-.343-.891-.839-.891-.839-.343.154-.7.308-1.045.462h0a26.465,26.465,0,0,1,5.756-8.65c.274-.274.548-.531.822-.788,0,0-.5-.394-1.045-.839s-.942-.7-.942-.7c-.206.188-.394.377-.6.582a26.414,26.414,0,0,0-7.3,13.7h0a27.264,27.264,0,0,0,6.252-2.038s-.617-.548-1.011-.891Z",
    transform: "translate(-64.569 -109.228)",
    fill: "#97999b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1663",
    "data-name": "Path 1663",
    d: "M140.622,73.9a32.506,32.506,0,0,0,9.421-21.1A32.621,32.621,0,0,0,135.5,57.168s.548.343,1.113.719,1.268.925,1.268.925a28.022,28.022,0,0,1,8-2.569l.856-.137h0l-.137.856a27.722,27.722,0,0,1-7.811,15.263l-.411.411s.668.428,1.131.685C139.971,73.6,140.622,73.9,140.622,73.9Z",
    transform: "translate(-119.347 -52.8)",
    fill: "#97999b"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1664",
    "data-name": "Path 1664",
    d: "M55.726,125.536A32.552,32.552,0,0,1,41.2,129.9a32.506,32.506,0,0,1,9.421-21.1s.5.223,1.148.6,1.113.668,1.113.668l-.411.411a27.585,27.585,0,0,0-7.794,15.262l-.137.856.856-.137a27.5,27.5,0,0,0,8-2.569s.737.582,1.165.874c.428.274,1.182.788,1.182.788Z",
    transform: "translate(-41.2 -99.904)",
    fill: "#97999b"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSage);
export default __webpack_public_path__ + "static/media/sage.e01e77ccb8bf71e165edc870296b1154.svg";
export { ForwardRef as ReactComponent };